// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_uiN4s","secondaryColumnCell":"secondary-column-cell_uiN4s","tooltip":"tooltip_WVARB"};